import BusinessKycList from '../components/request/RequestTypeForm/list/BusinessKyc';
import CarKycList from '../components/request/RequestTypeForm/list/CarKyc';
import CarPurchaseList from '../components/request/RequestTypeForm/list/CarPurchase';
import IndividualKycList from '../components/request/RequestTypeForm/list/IndividualKyc';
import TransactionRequestList from '../components/request/RequestTypeForm/list/TransactionRequest';
import KycList from '../components/request/RequestTypeForm/list/Kyc';

import TransactionEdit from '../components/request/RequestTypeForm/edit/Transaction';
import CarPurchaseEdit from '../components/request/RequestTypeForm/edit/CarPurchase';
import CarKycEdit from '../components/request/RequestTypeForm/edit/CarKyc';
import IndividualKycEdit from '../components/request/RequestTypeForm/edit/IndividualKyc';
import BusinessKycEdit from '../components/request/RequestTypeForm/edit/BusinessKyc';
import KycEdit from '../components/request/RequestTypeForm/edit/Kyc';

import TransactionCreate from '../components/request/RequestTypeForm/create/Transaction';
import CarPurchaseCreate from '../components/request/RequestTypeForm/create/CarPurchase';
import CarKycCreate from '../components/request/RequestTypeForm/create/CarKyc';
import IndividualKycCreate from '../components/request/RequestTypeForm/create/IndividualKyc';
import BusinessKycCreate from '../components/request/RequestTypeForm/create/BusinessKyc';
import KycCreate from '../components/request/RequestTypeForm/create/Kyc';

import { RequestTypes, requestTypes } from './requestTypes';

export const requestListMap: Record<RequestTypes, (props: any) => React.JSX.Element> = {
  [requestTypes.TRANSACTION]: TransactionRequestList,
  [requestTypes.CAR_PURCHASE]: CarPurchaseList,
  [requestTypes.CAR_KYC]: CarKycList,
  [requestTypes.INDIVIDUAL_KYC]: IndividualKycList,
  [requestTypes.BUSINESS_KYC]: BusinessKycList,
  [requestTypes.KYC]: KycList,
};

export const requestEditMap: Record<RequestTypes, (props?: any) => React.JSX.Element | null> = {
  [requestTypes.TRANSACTION]: TransactionEdit,
  [requestTypes.CAR_PURCHASE]: CarPurchaseEdit,
  [requestTypes.CAR_KYC]: CarKycEdit,
  [requestTypes.INDIVIDUAL_KYC]: IndividualKycEdit,
  [requestTypes.BUSINESS_KYC]: BusinessKycEdit,
  [requestTypes.KYC]: KycEdit,
};

export const requestCreateMap: Record<RequestTypes, (props?: any) => React.JSX.Element> = {
  [requestTypes.TRANSACTION]: TransactionCreate,
  [requestTypes.CAR_PURCHASE]: CarPurchaseCreate,
  [requestTypes.CAR_KYC]: CarKycCreate,
  [requestTypes.INDIVIDUAL_KYC]: IndividualKycCreate,
  [requestTypes.BUSINESS_KYC]: BusinessKycCreate,
  [requestTypes.KYC]: KycCreate,
};
